exports.closeSnapshots = (snapshots, closedStatus, user, closedAt) =>
  snapshots.map(snapshot => Object.assign({}, snapshot, {
    isComplete: true,
    closedStatus,
    closedBy: user.name,
    closedAt
  }))
